export default __webpack_public_path__ + "static/media/Talent_ComebackKid.9b593ec8.png";